__turbopack_context__.v({
  "arguments": "cli-graphic-module__9VH1hG__arguments",
  "canvas": "cli-graphic-module__9VH1hG__canvas",
  "command": "cli-graphic-module__9VH1hG__command",
  "completed": "cli-graphic-module__9VH1hG__completed",
  "graph": "cli-graphic-module__9VH1hG__graph",
  "inputFlag": "cli-graphic-module__9VH1hG__inputFlag",
  "response": "cli-graphic-module__9VH1hG__response",
  "response-first": "cli-graphic-module__9VH1hG__response-first",
  "response-second": "cli-graphic-module__9VH1hG__response-second",
  "response-third": "cli-graphic-module__9VH1hG__response-third",
  "runIcon": "cli-graphic-module__9VH1hG__runIcon",
  "running": "cli-graphic-module__9VH1hG__running",
  "scene": "cli-graphic-module__9VH1hG__scene",
  "started": "cli-graphic-module__9VH1hG__started",
  "terminal": "cli-graphic-module__9VH1hG__terminal",
  "titlebar": "cli-graphic-module__9VH1hG__titlebar",
  "transcript": "cli-graphic-module__9VH1hG__transcript",
  "windowDots": "cli-graphic-module__9VH1hG__windowDots",
});
